import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import CheckBox from "../../../shared/CheckBox";
import classNames from "classnames";

const LocationListItem = observer(
  class extends Component {
    render() {
      const props = this.props;
      const region = props.region;
      const editing = region.viewState.editing;
      const selected = region.viewState.selected;
      const name = region.name;
      const type = region.locationType.value;

      let onItemClick = this.props.onClick;
      let editingSection = null;
      if (editing) {
        onItemClick = region.toggleSelected;
        editingSection = (
          <CheckBox
            type={props.store.allowMultipleItemSelection ? "checkbox" : "radio"}
            name="list-item-select"
            value={name}
            selected={selected}
            style={{ width: 34 }}
            onClick={onItemClick}
          />
        );
      }

      return (
        <div className="ratecard-list-item-container">
          <div
            className={classNames("ratecard-list-item", { selected: selected })}
            onClick={onItemClick}
          >
            <div className="ratecard-list-item-left ellipsis">
              {editingSection}
              <div className="ratecard-label-container ellipsis">
                <div className="ratecard-label ellipsis">
                  <span className="ellipsis">{name}</span>
                </div>
                <div className="ratecard-meta ellipsis">
                  <span className="item-subtext-muted">{/*name*/} </span>
                </div>
              </div>
            </div>
            <div className="ratecard-list-item-right">
              <div className="ratecard-info w-300 text-center">
                <header>Type</header>
                <div>{type}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);

LocationListItem.propTypes = {
  store: PropTypes.object.isRequired,
  //rateCard: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default LocationListItem;
